var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    transform: "translate(0.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 124,
    width: 16,
    height: 39,
    rx: 4,
    fill: "#E5DDFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 111,
    width: 16,
    height: 52,
    rx: 4,
    fill: "#E5DDFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 88,
    width: 16,
    height: 75,
    rx: 4,
    fill: "#E5DDFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 102,
    width: 16,
    height: 61,
    rx: 4,
    fill: "#CBBBF7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 72,
    width: 16,
    height: 91,
    rx: 4,
    fill: "#E5DDFB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 58,
    width: 16,
    height: 105,
    rx: 4,
    fill: "#CBBBF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 107L59.3642 91.7945L86.3903 69.7864L111.206 72.7886L168.5 37",
    stroke: "#CBBBF7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 90,
    r: 6,
    fill: "#CBBBF7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 70,
    r: 6,
    fill: "#CBBBF7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 72,
    r: 6,
    fill: "#CBBBF7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.b53d99e849751bec3e349274a221827c.svg";
export { ForwardRef as ReactComponent };